import { render, staticRenderFns } from "./MinorRepudiating.vue?vue&type=template&id=211a245a&scoped=true&"
import script from "./MinorRepudiating.vue?vue&type=script&lang=js&"
export * from "./MinorRepudiating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211a245a",
  null
  
)

export default component.exports